module.exports = __webpack_public_path__ + "img/coral-gas-big.ed2b8e85.png";